import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './locales/it.json';
import en from './locales/en.json';

export const SUPPORTED_LANGS = ['it', 'en'];
export const DEFAULT_LANG = 'it';

// La lingua è determinata dall'URL (path-prefix): source of truth = la route.
// Allo startup leggiamo il pathname per evitare flash di lingua sui deep-link /en.
export function langFromPath(pathname) {
  const first = pathname.split('/').filter(Boolean)[0];
  return first === 'en' ? 'en' : DEFAULT_LANG;
}

const startupLang =
  typeof window !== 'undefined' ? langFromPath(window.location.pathname) : DEFAULT_LANG;

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: startupLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
